import React from 'react'
import { checkTranslation, translate } from '../../utils/useful'
import MembersList from '../../components/views/messenger/sideBar/MembersList'
import SidebarView from '../../components/SidebarView'
import TextInput from '../../components/inputs/TextInput'


class RoomsInfo extends React.Component {
    state = {

        isLoader: false,
        currentPage: 'voice',

        members: [
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "{{lang}}rooms.Online", role: "{{lang}}rooms.Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "{{lang}}rooms.Online", role: "{{lang}}rooms.Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "{{lang}}rooms.Online", role: "{{lang}}rooms.Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "{{lang}}rooms.Online", role: "{{lang}}rooms.Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "{{lang}}rooms.Online", role: "{{lang}}rooms.Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "{{lang}}rooms.Online", role: "{{lang}}rooms.Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "{{lang}}rooms.Online", role: "{{lang}}rooms.Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "{{lang}}rooms.Online", role: "{{lang}}rooms.Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "{{lang}}rooms.Online", role: "{{lang}}rooms.Owner" },
        ],

    }

    componentDidMount() {
        console.log('vthis.props.currentRoom', this.props.currentRoom)
        let roomName = this.props.currentRoom.title ?? ''
        this.setState({ roomName })
    }

    componentWillUnmount() {
    }


    changePage = (prop) => {
        this.setState({ currentPage: prop.key })
        this.stageManager.changeStage(prop.key)
    }

    openEdit = () => {
        this.edit.openSidebar()
    }

    changeValue = (key, value) => {
        this.setState({ [key]: value })
    }



    render() {
        return (
            <div className='flexcc h-100' style={{}}>
                <SidebarView hight={"100%"} width={this.props.width} ref={el => this.edit = el} hideOverlay={false} widthCondition={{ xs: "100%", sm: "100%", md: '50%', lg: "33.3%", xl: "25%" }}>
                    <div className='w-100 h-100 scroll-no-scrollbar px-2 py-2'>
                        <div className='pb-3' style={{ borderBottom: '1px solid #eee' }}>
                            <div className='w-100 flexcb'>
                                <button className='cancel-btn px-3 py-2 br-10'>
                                    <p>{translate('rooms.Discard')}</p>
                                </button>
                                <button className='save-btn px-3 py-2 br-10'>
                                    <p>{translate('rooms.Save')}</p>
                                </button>
                            </div>
                        </div>
                        <div className='flexc mt-3'>
                            <img className='br-50' width={80} src='/assets/icons/rooms/room-img.png' />
                            <div className='mld-3 w-100'>
                                <div className='flexcc blue-box-border-hover px-2 py-2 br-10'>
                                    <TextInput data={this.state.roomName} changeValue={this.changeValue} header={{ key: 'roomName', information: { rows: 1, placeholder: '{{lang}}rooms.Room Name' }, }} />
                                </div>
                                <p className='font-size-12 weight-300 main-c7'>{translate('rooms.Room Creator')}</p>
                                <p className='font-size-12 weight-300 main-c7'>23/4/23</p>
                            </div>
                        </div>
                        <div className='mt-3'>
                            <div className='p-3 br-10' style={{ backgroundColor: "#f6f6f6", }}>
                                <p className='pb-2 font-size-10' style={{ color: "#7064FE", borderBottom: "1px solid #eee" }}>{translate('rooms.Description')}</p>
                                <div className='flexcc blue-box-border-hover px-2 mt-3 py-2 br-10'>
                                    <TextInput data={this.state.roomDiscription} changeValue={this.changeValue} header={{ key: 'roomDiscription', information: { row: 'multi', placeholder: '{{lang}}rooms.Room Description' }, }} />
                                </div>
                            </div>
                        </div>
                        <div className='mt-3'>
                            <div className='p-3 br-10' style={{ backgroundColor: "#f6f6f6", }}>
                                <p className='pb-2 font-size-10' style={{ color: "#7064FE", borderBottom: "1px solid #eee" }}>{translate("rooms.Room's Link")}</p>
                                <button className='w-100 flexcb pt-2 '>
                                    <p className='font-size-12 weight-300' style={{ color: "#7064FE" }}>/rooms/dfgfud0vreu</p>
                                    <img className='flexcc' width={20} src='/assets/icons/rooms/copy.svg' />
                                </button>
                            </div>
                        </div>
                    </div>
                </SidebarView>
                <div className=' w-100 h-100'>
                    <div className='flexc'>
                        <img className='br-50' width={80} src='/assets/icons/rooms/room-img.png' />
                        <div className='mld-3 w-100'>
                            <div className='flexcb w-100'>
                                <p className='font-size-16 weight-500 main-c3'>{this.props.currentRoom?.title ?? translate('rooms.Room Name')}</p>
                                <button className='flexc back-purple px-3 py-2 br-10' onClick={() => this.openEdit()}>
                                    <img width={18} src='/assets/icons/rooms/edit.svg' />
                                    <p className='mld-2' style={{ color: "#7064FE" }}>{translate('rooms.Edit')}</p>
                                </button>
                            </div>
                            <p className='font-size-12 weight-300 main-c7'>{this.props.currentRoom?.owner?.fullname ?? translate('rooms.Room Creator')}</p>
                            <p className='font-size-12 weight-300 main-c7'>{this.props.showDate(this.props.currentRoom.cDate)}</p>
                        </div>
                    </div>
                    <div className='mt-3'>
                        <div className='p-3 br-10' style={{ backgroundColor: "#fff", }}>
                            <p className='pb-2 font-size-10' style={{ color: "#7064FE", borderBottom: "1px solid #eee" }}>{translate('rooms.Description')}</p>
                            <p className='font-size-12 pt-2 weight-300 main-c7'>{this.props.currentRoom.description}</p>
                        </div>
                    </div>
                    <div className='mt-3'>
                        <div className='p-3 br-10' style={{ backgroundColor: "#fff", }}>
                            <p className='pb-2 font-size-10' style={{ color: "#7064FE", borderBottom: "1px solid #eee" }}>{translate("rooms.Room's Link")}</p>
                            <button className='w-100 flexcb pt-2 '>
                                <p className='font-size-12 weight-300' style={{ color: "#7064FE" }}>/rooms/{this.props.currentRoom.roomId}</p>
                                <img className='flexcc' width={20} src='/assets/icons/rooms/copy.svg' />
                            </button>
                        </div>
                    </div>
                    <div className='mt-3'>
                        <div className='p-3 br-10' style={{ backgroundColor: "#fff", }}>
                            <div className='flexcb w-100 pb-3' style={{ borderBottom: "1px solid #eee" }}>
                                <p className=' font-size-10' style={{ color: "#7064FE", }}>{translate('rooms.Members')}</p>
                                <div className=''>
                                    <div className="br-10" style={{ backgroundColor: '#f6f6f6', }}>
                                        <input className="py-1 px-2 w-100 change-placeHolder" value={this.state.listSearch} onChange={(e) => this.searchHub(e)} placeholder={translate('rooms.Search')} style={{ backgroundColor: 'transparent', border: 'none', color: "#444" }} />
                                    </div>
                                </div>
                            </div>
                            {this.props.currentRoom?.participants?.map((prop, index) => {
                                return (
                                    <div className='flexcb w-100 py-3 bb-gray'>
                                        <div className='flexc'>
                                            <img width={35} src={prop.img} />
                                            <p className='font-size-12 main-c4 mld-3'>{prop.fullname}</p>
                                        </div>
                                        {/* <div>
                                            <p className='font-size-10 main-c7'>{checkTranslation(prop.state)}</p>
                                        </div> */}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default RoomsInfo;